<template>

    <div class="page">
        <SidebarBody/>
        <TransactionsBody/>
    </div>
    
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import SidebarBody from "@/components/master/SidebarBody.vue";
  import TransactionsBody from "@/components/master/TransactionsBody.vue";
  
  export default defineComponent({
    name: "MasterTransactionsView",
    components: {
      SidebarBody,
      TransactionsBody
    },
  });
  </script>
  